<div class="content-header">
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb breadcrumb_style">
            <!-- <li class="breadcrumb-item"><a>Dashboard/{{currentLink}}</a></li> -->
            <li class="breadcrumb-item d-none d-md-flex">
                <a *ngIf="currentLink === 'Dashboard'"
                    >Welcome back, {{ name }}</a
                >
                <a *ngIf="currentLink !== 'Dashboard'">{{ currentLink }}</a>
            </li>
        </ol>
    </nav>
    <div class="header_right">
        <div class="header_right_left">
            <!-- <a>
          <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none"
            stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          </svg>
        </a>
        <a >
          <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none"
            stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1">
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
            <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
          </svg>
        </a> -->
        </div>
        <div>
            <li class="breadcrumb-item">
                <a class="mobile_asside_menu_btn" (click)="toggleMenu()">
                    <svg
                        viewBox="0 0 24 24"
                        width="24"
                        height="24"
                        stroke="currentColor"
                        stroke-width="2"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="css-i6dzq1"
                    >
                        <line x1="21" y1="10" x2="3" y2="10"></line>
                        <line x1="21" y1="6" x2="3" y2="6"></line>
                        <line x1="21" y1="14" x2="3" y2="14"></line>
                        <line x1="21" y1="18" x2="3" y2="18"></line>
                    </svg>
                </a>
            </li>
        </div>
        <div class="create_new_title">
            <div
                class="plusCircle"
                data-bs-toggle="modal"
                data-bs-target="#addnewstudiomodal"
            >
                <span class="title_text">
                    {{ navigation.createTitle }}
                    <img src="/assets/images/dashboard-icons/plus.svg"
                /></span>
            </div>
        </div>
        <!-- <select id="languageSelect" name="language" class="me_4" [value]="language" (change)="changeLanguage($event)">
      <option value="en">English</option>
      <option value="hi">Hindi</option>
      <option value="zh-CN">Mandarin</option>
      <option value="ko">Korean</option>
      <option value="es">Spanish</option>
      <option value="fr">French</option>
      <option value="ja">Japanese</option>
      <option value="pt">Portuguese</option>
      <option value="it">Italian</option>
    </select> -->
        <!-- <div class="header_right_right"> -->

        <!-- <div class="mvp_account_header"> -->
        <!-- <div class="mvp_account_icon">
          <span>
            {{shortname | uppercase}}
          </span> -->
        <!-- <span *ngIf="imageUrl" [ngClass]="dynamicColor" (click)="this.isProfile=!this.isProfile">
              <img [src]="imageUrl" alt="">
            </span> -->
        <!-- <img src="/assets/images/dashboard-icons/online.svg" class="online-indicator" /> -->

        <!-- </div>
        <div class="mvp_account_body">
          <p>
            <span class="mvp_account_body_title">{{name ||'John Deo'}}</span>
            {{dashbaordData.admin}}
          </p>
        </div> -->
        <!-- <div class="mvp_account_icon">
            <span *ngIf="imageUrl==''">
             {{shortName}}
            </span>
            <span *ngIf="imageUrl">
              <img [src]="imageUrl" alt="not found" (error)="handleImageError()">
             </span>
          </div> -->

        <!-- </div> -->
        <!-- </div> -->
    </div>
</div>

<div class="aside_menu" [class.open]="menuOpen">
    <div class="px-4 pt-3 d-flex flex-row align-items-center justify-between">
        <a [routerLink]="['./']" class="aside-logo">
            <img src="/assets/images/logo.svg" alt="" />
        </a>
        <button
            (click)="closeMenu()"
            style="background: transparent; padding: 0px"
        >
            <img src="/assets/images/dashboard-icons/close.svg" alt="" />
        </button>
    </div>
    <ul class="nav-aside">
        <li class="nav-item">
            <a
                class="nav-link"
                [routerLink]="['/dashboard']"
                (click)="closeMenu()"
            >
                <img
                    src="/assets/images/dashboard-icons/home-icon.svg"
                    alt=""
                />
                Welcome back, {{ navigation.dashboardTitle }}</a
            >
        </li>
        <li class="nav-item_mobile has-dropdown" [class.open]="titlesOpen">
            <div class="d-flex flex-row align-items-center space-betwween">
                <a class="nav-link" (click)="toggleTitles()">
                    <img
                        src="/assets/images/dashboard-icons/folder.svg"
                        alt=""
                    />
                    {{ navigation.sidebarTitle }}
                </a>
                <div class="arrow_div">
                    <img
                        src="/assets/images/dashboard-icons/chevron-up.svg"
                        alt=""
                        *ngIf="titlesOpen"
                    />
                    <img
                        src="/assets/images/dashboard-icons/chevron-up.svg"
                        alt=""
                        *ngIf="!titlesOpen"
                        class="rotate-180"
                    />
                </div>
            </div>
            <ul class="dropdown" *ngIf="titlesOpen">
                <li class="w-100" *ngIf="dropDown.length != 0">
                    <div *ngFor="let d of dropDown" class="px-2">
                        <p
                            class="cursor"
                            [ngClass]="
                                d.data?.status == 1 ? 'nav_label_text' : ''
                            "
                            (click)="openDropdown(d.data?.id)"
                        >
                            {{ d.data?.title }}
                        </p>
                        <ul class="nav-aside mb-3" *ngIf="d.data?.status == 1">
                            <li class="nav-item">
                                <a
                                    class="nav-link"
                                    [routerLink]="['/dashboard/title']"
                                    (click)="closeMenu()"
                                    title="{{ navigation.files }}"
                                    >{{ navigation.files }}</a
                                >
                            </li>
                            <li class="nav-item">
                                <a
                                    class="nav-link"
                                    [routerLink]="['/dashboard/metadata']"
                                    (click)="closeMenu()"
                                    title="{{ navigation.metadata }}"
                                    >{{ navigation.metadata }}</a
                                >
                            </li>
                            <li
                                class="nav-item"
                                *ngIf="
                                    d.role == 'Administrator' ||
                                    d.role == 'Admin'
                                "
                            >
                                <a
                                    class="nav-link"
                                    [routerLink]="['/dashboard/member']"
                                    (click)="closeMenu()"
                                    title="{{ navigation.Members }}"
                                    >{{ navigation.Members }}</a
                                >
                            </li>
                            <li
                                class="nav-item"
                                *ngIf="
                                    d.role == 'Administrator' ||
                                    d.role == 'Admin'
                                "
                            >
                                <a
                                    class="nav-link"
                                    [routerLink]="['/dashboard/order-history']"
                                    (click)="closeMenu()"
                                    title="{{ navigation.orderHistory }}"
                                    >{{ navigation.orderHistory }}</a
                                >
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
        </li>
        <li class="nav-item">
            <a
                class="nav-link"
                [routerLink]="['/dashboard/billing-details']"
                (click)="closeMenu()"
            >
                <img
                    src="/assets/images/dashboard-icons/billing-icon.svg"
                    alt=""
                />
                {{ navigation.billingDetails }}</a
            >
        </li>
        <li class="nav-item_mobile has-dropdown" [class.open]="accountOpen">
            <div class="d-flex flex-row align-items-center space-betwween">
                <a class="nav-link" (click)="toggleAccount()">
                    <img
                        src="/assets/images/dashboard-icons/settings-icon.svg"
                        alt=""
                    />
                    {{ navigation.accountSettings }}
                </a>
                <div class="arrow_div">
                    <img
                        src="/assets/images/dashboard-icons/chevron-up.svg"
                        alt=""
                        *ngIf="accountOpen"
                    />
                    <img
                        src="/assets/images/dashboard-icons/chevron-up.svg"
                        alt=""
                        *ngIf="!accountOpen"
                        class="rotate-180"
                    />
                </div>
            </div>
            <ul class="dropdown" *ngIf="accountOpen">
                <li class="nav-item">
                    <a
                        class="nav-link"
                        [routerLink]="['/dashboard/profile-settings']"
                        (click)="closeMenu()"
                        >{{ navigation.profileSetting }}</a
                    >
                </li>
                <li class="nav-item">
                    <a
                        class="nav-link"
                        [routerLink]="['/dashboard/account-details']"
                        (click)="closeMenu()"
                        >{{ navigation.accountDetails }}</a
                    >
                </li>
                <li class="nav-item">
                    <a
                        class="nav-link"
                        [routerLink]="['/dashboard/cloud-storage']"
                        (click)="closeMenu()"
                        >{{ navigation.cloudStorage }}</a
                    >
                </li>
                <li class="nav-item">
                    <a
                        class="nav-link"
                        [routerLink]="['/dashboard/manage-title']"
                        (click)="closeMenu()"
                        >{{ navigation.manageTitle }}</a
                    >
                </li>
            </ul>
        </li>

        <div class="header_right_right">
            <a
                class="nav-link"
                (click)="hideSideBar()"
                data-bs-toggle="modal"
                data-bs-target="#logoutmodal"
            >
                <div class="mvp_account_header">
                    <div class="mvp_account_header_inner">
                        <div class="mvp_account_icon">
                            <span>
                                {{ shortname | uppercase }}
                            </span>
                            <!-- <span *ngIf="imageUrl" [ngClass]="dynamicColor" (click)="this.isProfile=!this.isProfile">
              <img [src]="imageUrl" alt="">
            </span> -->
                            <img
                                src="/assets/images/dashboard-icons/online.svg"
                                class="online-indicator"
                            />
                        </div>
                        <div class="mvp_account_body">
                            <p>
                                <span class="mvp_account_body_title">{{
                                    name || 'John Deo'
                                }}</span>
                                {{ dashbaordData.admin }}
                            </p>
                        </div>
                    </div>
                    <!-- <div class="mvp_account_icon">
            <span *ngIf="imageUrl==''">
             {{shortName}}
            </span>
            <span *ngIf="imageUrl">
              <img [src]="imageUrl" alt="not found" (error)="handleImageError()">
             </span>
          </div> -->
                    <div>
                        <img
                            src="/assets/images/dashboard-icons/chevron-selector-vertical.svg"
                        />
                    </div>
                </div>
            </a>
        </div>
        <li class="nav-item">
            <select
                id="languageSelect"
                name="language"
                class="select_lang"
                [value]="language"
                (change)="changeLanguage($event)"
            >
                <option value="en">English</option>
                <option value="hi">Hindi</option>
                <option value="zh-CN">Mandarin</option>
                <option value="ko">Korean</option>
                <option value="es">Spanish</option>
                <option value="fr">French</option>
                <option value="ja">Japanese</option>
                <option value="pt">Portuguese</option>
                <option value="it">Italian</option>
            </select>
        </li>
    </ul>
</div>
<div class="menu_overlay" *ngIf="menuOpen" (click)="toggleMenu()"></div>

<div
    class="modal fade"
    id="logoutmodal"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
>
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body logout_modal_body">
                <div class="logout_modal_body_inner">
                    <img
                        src="/assets/images/cancel.png"
                        class="logout_cancel"
                        alt=""
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    />
                    <p class="logout_heading">Logout Confirmation</p>
                    <p class="logout_sub_heading">
                        Are you sure you want to log out? Logging out will end
                        your current session.
                    </p>
                </div>
            </div>
            <div class="modal-footer logout_modal_footer">
                <button
                    type="button"
                    class="btn logout_modal_cancel_btn"
                    #modalCloseButton1
                    data-bs-dismiss="modal"
                >
                    Cancel
                </button>
                <button
                    type="button"
                    class="btn logout_modal_btn"
                    (click)="logout()"
                >
                    Logout
                </button>
            </div>
        </div>
    </div>
</div>
